import React, { useEffect } from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Grid, Paper, Switch, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TripleToggle from '../layouts/TripleToggle';
const useStyles = makeStyles(theme => ({
  dialogContainer: {
    minWidth: "320px",
    textAlign: "center",
    paddingBottom: "5vh"
  },
  disclaimerSwitchWrapper: {
    marginTop: "1vh",
    marginBottom: "1vh",
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center"
  },
  captionWrapper: {
    maxWidth: "80%",
    marginTop: "1vh",
    marginBottom: "2vh",
    padding: "2vh",
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center"
  },
  fieldTitle: {
    fontWeight: "bold"
  },
  choiceNo: {
    color: "red"
  },
  choiceYes: {
    color: "green"
  },
  switchToggle: {
    width: "10em"
  }
}));
const TermsDialog = props => {
  const classes = useStyles();
  const [termsChoice, setTermsChoice] = useState('');
  const [noChoice, setNoChoice] = useState(true);
  const handleToggle = (type, value) => {
    switch (value) {
      case "1":
        setTermsChoice(true);
        break;
      case "0":
        setTermsChoice(false);
        break;
      default:
        break;
    }
    setNoChoice(false);
  };
  useEffect(() => {
    console.log('termsChoice changed to ' + termsChoice);
  }, [termsChoice]);
  const submitChoice = () => {
    props.sendChoice(termsChoice);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.dialogContainer
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.captionWrapper
  }, "J.T. International (Romania) SRL \u2013 JTI (Bd. Dimitrie Pompei nr. 9-9A, sector 2, Bucuresti) prelucreaza datele cu caracter personal (\u201CDatele\u201D) furnizate de dvs., in conformitate cu legislatia nationala si europeana in urmatoarele scopuri: 1. participare la campanii promotionale 2. justificare din punct de vedere fiscal a acordarii premiilor, declararea si retinerea impozitului pe veniturile din premii, 3. marketing - transmiterea de comunicari comerciale si 4. studii / cercetare de piata avand ca temeiuri juridice: pentru scopul de la pct 1 de mai sus - interesul legitim de a asigura participarea la campaniile promotionale a unor consumatori fumatori adulti reali si oferirea de premii catre acestia, pentru scopul de la pct. 2 de mai sus - indeplinirea obligatiilor ce ii revin JTI in conformitate cu legislatia fiscala in vigoare si pentru scopurile de la pct 3 si 4 - consimtamantul liber exprimat de dvs. prin formularul / contul de participare la una din campaniile promotionale ale JTI. JTI va dezvalui aceste date imputernicitilor sai, autoritatilor sau altor destinatari. Cu privire la Datele prelucrate, in functie de scopul prelucrarii va sunt garantate urmatoarele drepturi: acces, rectificare, restrictionare, opozitie, portabilitate si stergere. Oricare dintre aceste drepturi poate fi exercitat prin trimiterea unui email la adresa dataprotection@mypass.ro. De asemenea, va este recunoscut dreptul de a depune o plangere la Autoritatea Nationala de Supraveghere a Prelucrarii Datelor cu Caracter Personal. Pentru mai multe informatii referitoare la categoriile de Date prelucrate, durata prelucrarii, categoriile de destinatari, alte mijloace de exercitare a drepturilor ce va revin, consultati Politica de confidentialitate si protectie a datelor. Datele declarate de dumneavoastra trebuie sa fie reale, corecte si sa va apartina."), /*#__PURE__*/React.createElement(TripleToggle, {
    toggleAction: handleToggle,
    toggleType: "terms",
    yesLabel: "Sunt de acord",
    noLabel: "Nu sunt de acord"
  }), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: submitChoice,
    disabled: noChoice,
    style: {
      marginTop: "3vh"
    }
  }, "Trimite")));
};
TermsDialog.propTypes = {
  sendChoice: PropTypes.func
};
export default TermsDialog;